import React, { useState, useEffect, useCallback } from 'react';
import { getBrands } from '../services/api';

const FALLBACK_BRANDS = [
  { name: 'Sedal', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/zaztwzoi_Screenshot_158.jpg', scale: 1.2 },
  { name: 'Maybelline', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/22lede1e_Maybelline-logo.png', scale: 1.8 },
  { name: 'Neutrogena', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/4u55tu5x_neutrogena-1-logo-black-and-white.png', scale: 2.4 },
  { name: 'Rimmel', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/vooang86_Screenshot_145.jpg', scale: 1.2 },
  { name: 'Disney Plus', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/w7hlfwfc_images%20%281%29.png', scale: 2.4 },
  { name: 'Garnier', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/x4itgnos_Screenshot_157.jpg', scale: 0.8 },
  { name: 'La Roche-Posay', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/lrb8xnuf_Screenshot_147.jpg', scale: 1.98 },
  { name: 'YPF', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/4sd0ugoy_ed908349a40c0d489f89e34edcb34c21.jpg', scale: 2.4 },
  { name: 'Mostaza', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/x5svxk3t_Screenshot_166.jpg', scale: 1.2 },
  { name: "L'Oréal", logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/rv7caca9_Screenshot_152.jpg', scale: 1.2 },
  { name: 'Rappi', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/ess7efrb_Screenshot_146.jpg', scale: 1.2 },
  { name: 'Simplicity', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/m4jqb9tz_Screenshot_151.jpg', scale: 1.2 },
  { name: 'Converse', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/kbggol8f_Screenshot_154.jpg', scale: 1.2 },
  { name: 'Always', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/6e9jfbhu_Screenshot_163.jpg', scale: 1.2 },
  { name: 'Dove', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/gqaegqvn_Screenshot_162.jpg', scale: 1.2 },
  { name: 'GUM', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/0h4l82zl_Screenshot_156.jpg', scale: 1.2 },
  { name: 'Mercado Libre', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/mh37xdzm_Screenshot_155.jpg', scale: 1.2 },
  { name: 'Naranja X', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/nfwgidaz_1620312464164.webp', scale: 1.8 },
  { name: 'Flow', logo: 'https://customer-assets.emergentagent.com/job_aea6bcc2-c219-44bf-9871-9a871cd06767/artifacts/zogzwp1n_Flow_logo_2021.svg.png', scale: 0.84 },
  { name: "Victoria's Secret", logo: 'https://customer-assets.emergentagent.com/job_e5e0b548-5d46-45b3-9c33-35f27ba77bc9/artifacts/d341d62d_Screenshot_53.jpg', scale: 1.4 },
];

const BrandItem = ({ brand }) => {
  const baseHeight = 48;
  const height = Math.round(baseHeight * (brand.scale || 1.2));
  
  return (
    <img
      src={brand.logo}
      alt={brand.name}
      style={{ height: `${height}px` }}
      className="w-auto object-contain"
    />
  );
};

const BrandsSection = () => {
  const [brands, setBrands] = useState(FALLBACK_BRANDS);

  const fetchBrands = useCallback(async () => {
    try {
      const data = await getBrands();
      if (data && data.length > 0) {
        setBrands(data);
      }
    } catch (err) {
      console.error('Failed to fetch brands:', err);
    }
  }, []);

  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  // Duplicate brands enough times so all are visible in the scroll
  const scrollBrands = [...brands, ...brands, ...brands, ...brands];
  // 85% faster: original was ~50s equivalent, now ~8s
  const duration = Math.max(brands.length * 0.4, 8);

  return (
    <section className="py-8 overflow-hidden" style={{ backgroundColor: '#FFFDEB' }} data-testid="brands-section">
      <style>
        {`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-25%); }
          }
        `}
      </style>

      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 mb-6">
        {/* Label */}
        <div className="flex items-center gap-4 mb-10">
          <div className="w-10 h-[3px]" style={{ backgroundColor: '#742263' }} />
          <span className="text-sm md:text-base font-semibold tracking-[0.3em] uppercase" style={{ fontFamily: "'DM Sans', sans-serif", color: '#742263' }}>
            Marcas
          </span>
        </div>
        <h2 className="text-5xl md:text-7xl lg:text-8xl leading-none tracking-tight" style={{ fontFamily: "'Bebas Neue', sans-serif", color: 'rgba(74,21,75,0.18)' }}>
          Confian en nosotros
        </h2>
      </div>

      <div className="relative py-6" style={{ backgroundColor: '#ffffff' }}>
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10" style={{ background: 'linear-gradient(to right, #ffffff, transparent)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10" style={{ background: 'linear-gradient(to left, #ffffff, transparent)' }} />
        
        <div 
          className="flex items-center"
          style={{
            animation: `scrollLeft ${duration}s linear infinite`,
            width: 'fit-content',
          }}
        >
          {scrollBrands.map((brand, index) => (
            <div 
              key={`${brand.name}-${index}`}
              className="flex-shrink-0 flex items-center justify-center px-2.5 md:px-3.5 h-32"
            >
              <BrandItem brand={brand} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
